module.exports = __webpack_public_path__ + "static/media/painting-hand.e078d2e4.png";